/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { withRouter, Link } from "react-router-dom";
import {
  Alert,
  BackButton,
  Button,
  Breadcrumbs,
  Text,
  MandatoryFieldText,
  InputContainer,
  SendToast,
  Wrapper,
} from "@networkraildigitalfactory/components";
import emojiStrip from "emoji-strip";
import styles from "./BeginOneToOne.module.css";
import ViewOneToOneData from "../ViewOneToOneData/ViewOneToOneData";
import { useOneToOnes, useUsers } from "../../hooks/useAPI";
import { a11yGrowTextarea, getEmployeeEmailByPathname } from "../../services/utils";
import StatusLabel from "../StatusLabel/StatusLabel";
import useUser from "../../hooks/useUser";

const BeginOneToOne = (props) => {
  const { register, errors, getValues, triggerValidation } = useForm();
  // eslint-disable-next-line no-unused-vars
  const [oneToOneValues, setOneToOneValues] = useState({});
  const [{ data: oneToOneData, loading: oneToOnesLoading }, getOneToOne] = useOneToOnes(
    props.match.params.id
  );
  const [isLoading, setLoading] = useState(false);

  const { isGBR } = useUser();
  const isLineManager = localStorage.getItem("isLineManager");
  const { user, isDirtyForm, setIsDirtyForm, setNavModalProps } = props;

  const email = getEmployeeEmailByPathname(props.history.location.pathname, "/begin-1-2-1");

  const [{ data: employeeBeingViewed }] = useUsers(email);
  let fullName;
  if (employeeBeingViewed) {
    // eslint-disable-next-line prefer-destructuring
    fullName = employeeBeingViewed.fullName;
  }
  const prepHeading =
    employeeBeingViewed || (!employeeBeingViewed && oneToOneData && !oneToOneData.isCompleted)
      ? "1-2-1"
      : "1-2-1 Prep";

  const prepText = isGBR
    ? `What would you like to celebrate?`
    : `What are some of your biggest
  successes since your last 1-2-1?`;

  const navTo = (dest) => props.history.push(dest);

  const inputKeydown = () => {
    setIsDirtyForm(true);
    if (Object.keys(errors).length > 0) {
      triggerValidation();
    }
  };

  const onInputChange = (field, value) => {
    setOneToOneValues((prevFormValues) => ({
      ...prevFormValues,
      [field]: emojiStrip(value),
    }));
    setIsDirtyForm(true);
  };

  const handleGetOneToOnes = async () => {
    const result = await getOneToOne();
    if (result) {
      setOneToOneValues(result.data);
    }
    setTimeout(() => {
      setLoading(false);
    }, 325);
  };

  useEffect(() => {
    if (props.match.params.id) {
      setLoading(true);
      handleGetOneToOnes();
    }
  }, []);

  const [{ error: errPut }, updateOneToOne] = useOneToOnes(
    {
      url: props.match.params.id,
      method: "PUT",
    },
    { manual: true }
  );

  const [{ error: errPost }, createOneToOne] = useOneToOnes(
    {
      url: "admin",
      method: "POST",
    },
    { manual: true }
  );

  const buildUpdatePayload = (data) => {
    const ret = {
      ...data,
      status: "completed",
      currentFeedback: data.currentFeedback,
    };

    return ret;
  };

  const buildCreatePayload = (data) => {
    const ret = {
      status: "completed",
      email: props.match.params.email,
      period: props.match.params.period,
      financialYear: props.match.params.year.replace("-", "/"),
      prep: {
        successDesc: "",
        challengesDesc: "",
        objectives: [],
        discussObjective: false,
        objectivesDesc: "",
        isPrepCompleted: false,
        isPrepStarted: false,
        wellBeingFeeling: 0,
        additionalComments: "",
      },
      comments: [],
      additionalLmFeedback: "",
      lmFeedback: "",
      isCompleted: true,
      currentFeedback: data.currentFeedback,
    };

    return ret;
  };

  const onSave = async () => {
    const isValid = await triggerValidation();
    if (isValid) {
      if (oneToOneValues._id) {
        await updateOneToOne({ data: buildUpdatePayload(oneToOneValues) });
      } else {
        await createOneToOne({ data: buildCreatePayload(oneToOneValues) });
      }
      setIsDirtyForm(false);
      SendToast("1-2-1 has been succesfully completed", "success");
      navTo(`/my-team/${email}/oneToOnes`);
    }
  };

  if (errPut || errPost) return SendToast("1-2-1 hasn't been completed. Please try again", "error");

  return (
    <>
      <div className={styles.breadcrumbs_wrapper}>
        <Breadcrumbs
          items={[
            {
              text: "My Team",
              onClick: () => {
                if (isDirtyForm) {
                  setNavModalProps({ show: true, navPath: "/my-team" });
                } else {
                  navTo("/my-team");
                }
              },
            },
            {
              text: fullName,
              onClick: () => {
                if (isDirtyForm) {
                  setNavModalProps({ show: true, navPath: `/my-team/${email}/oneToOnes` });
                } else {
                  navTo(`/my-team/${email}/oneToOnes`);
                }
              },
            },
            { text: "Start 1-2-1" },
          ]}
        />
      </div>
      {!oneToOnesLoading && !isLoading && (
        <Wrapper maxWidth={1350} align="center">
          {isDirtyForm && (
            <Alert
              color="red"
              title="Unsaved Changes"
              message="You must save or submit your changes before navigating to another page. If you do not select save, all changes will be lost."
              style={{
                lineHeight: "140%",
                letterSpacing: "0.0015em",
                padding: "8px 10px 8px 10px",
              }}
            />
          )}
          <div className={styles.row}>
            <BackButton
              text="back to 1-2-1s"
              onClick={() => {
                if (isDirtyForm) {
                  setNavModalProps({ show: true, navPath: `/my-team/${email}/oneToOnes` });
                } else {
                  navTo(`/my-team/${email}/oneToOnes`);
                }
              }}
              style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
            />
            <StatusLabel status="In progress" />
          </div>
          <div className={styles.info}>
            Please conduct your 1-2-1 with your employee and add any feedback in the line manager's
            feedback section.
          </div>
          <div className={styles.light_bg}>
            <Text
              wrapper="h2"
              type="header"
              style={{ margin: "0", lineHeight: "140%", letterSpacing: "0.0015em" }}
            >
              {oneToOneData.period && `${prepHeading}: Period ${oneToOneData.period}`}
              {props.match.params.period && `${prepHeading}: Period ${props.match.params.period}`}
            </Text>
            <div className={styles.mandatory}>
              <MandatoryFieldText />
            </div>
            {!oneToOnesLoading &&
              !isLoading &&
              props.match.params.id &&
              !(employeeBeingViewed && !oneToOneData.prep.isPrepCompleted) && (
                <ViewOneToOneData
                  data={oneToOneData}
                  isLineManager={isLineManager}
                  user={user}
                  employeeBeingViewed={isLineManager ? employeeBeingViewed : null}
                />
              )}
            {!oneToOnesLoading &&
              (!props.match.params.id ||
                (employeeBeingViewed && !oneToOneData.prep.isPrepCompleted)) && (
                <div>
                  <Text
                    style={{
                      color: "#000000",
                      fontSize: "18px",
                      lineHeight: "140%",
                      letterSpacing: "0.0015em",
                    }}
                  >
                    No prep completed.
                  </Text>
                  <Text
                    style={{
                      color: "#000000",
                      fontSize: "18px",
                      lineHeight: "140%",
                      letterSpacing: "0.0015em",
                    }}
                  >
                    Please use the questions below to guide the conversation:
                  </Text>
                  <Text
                    style={{
                      color: "#000000",
                      fontSize: "18px",
                      lineHeight: "140%",
                      letterSpacing: "0.0015em",
                    }}
                  >
                    {prepText} <br />
                    What have you found challenging? <br />
                    Is there any particular objective you’d like to discuss? <br />
                    How are you feeling?
                  </Text>
                </div>
              )}
            <Text
              type="body"
              wrapper="span"
              size="18px"
              style={{
                margin: "0.4rem 0",
                lineHeight: "140%",
                letterSpacing: " 0.0015em",
                textDecoration: "underline",
              }}
            >
              <Link
                name="click objectives"
                style={{
                  fontSize: "18px",
                  padding: 0,
                  color: "#000000",
                  float: "left",
                  textDecoration: "underline",
                }}
                to={`/my-team/${email}/objectives`}
                target="_blank"
              >
                Click here to view {fullName}'s objectives
              </Link>
            </Text>
            <Text
              wrapper="h2"
              type="header"
              style={{
                fontSize: "28px",
                lineHeight: "140%",
                letterSpacing: "0.0015em",
                margin: "12px 0px 0px 0px",
              }}
            >
              Line manager’s feedback
            </Text>
            <form className={styles.form} role="presentation">
              <InputContainer
                labelText="How was the 1-2-1?"
                required
                forLabel="currentFeedback"
                errorText={errors.currentFeedback && errors.currentFeedback.message}
              >
                <textarea
                  name="currentFeedback"
                  id="currentFeedback"
                  onPaste={inputKeydown}
                  ref={register({
                    required: "Must not be blank",
                  })}
                  className={`${styles.form_textarea} ${
                    errors.currentFeedback ? styles.error : ""
                  }`}
                  defaultValue=""
                  onChange={(e) => {
                    inputKeydown();
                    onInputChange("currentFeedback", e.target.value, false);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onInputChange("currentFeedback", e.target.value, true);
                    }
                    a11yGrowTextarea(e, "currentFeedback");
                  }}
                />
              </InputContainer>
            </form>
          </div>
          <div className={styles.button_actions}>
            <Button
              className={styles.save_comment_Btn}
              style={{
                backgroundColor: oneToOneValues.currentFeedback ? "#37519D" : "#727272",
                marginRight: 70,
              }}
              text="Finish 1-2-1"
              onClick={() => {
                onSave(getValues());
              }}
            />
          </div>
        </Wrapper>
      )}
    </>
  );
};
export default withRouter(BeginOneToOne);
